import React, { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { authAPI } from '../services/api';

/** Public page hit by clicking the link in the restore-account email.
 *  Reads ?token=..., POSTs to /auth/restore on mount. On success the
 *  backend has cleared deleted_at and the user can sign in normally. */
export default function RestorePage() {
  const [params] = useSearchParams();
  const token    = params.get('token') || '';
  // 'working' until the backend responds; 'done' on success; 'failed' otherwise.
  const [state, setState]     = useState(token ? 'working' : 'failed');
  const [errMsg, setErrMsg]   = useState(token ? '' : 'Missing restore token in the URL.');
  const [email,  setEmail]    = useState('');

  useEffect(() => {
    if (!token) return;
    authAPI.restoreAccount(token)
      .then(res => {
        setEmail(res?.data?.email || '');
        setState('done');
      })
      .catch(err => {
        setErrMsg(err.response?.data?.error || 'This restore link is no longer valid.');
        setState('failed');
      });
  }, [token]);

  return (
    <div style={pageStyle}>
      <div style={cardStyle}>
        <Link to="/" style={brand}>
          <span style={brandMark}>🎬</span>
          <span style={brandName}>CreatorKhata</span>
        </Link>

        {state === 'working' && (
          <>
            <div style={{ fontSize: '2.5rem', marginBottom: '0.5rem' }}>⏳</div>
            <h1 style={title}>Restoring your account…</h1>
            <p style={sub}>Just a moment.</p>
          </>
        )}

        {state === 'done' && (
          <>
            <div style={{ fontSize: '2.5rem', marginBottom: '0.5rem' }}>✅</div>
            <h1 style={title}>Account restored</h1>
            <p style={sub}>
              {email
                ? <>You can now sign in with <strong>{email}</strong> — your data is exactly as you left it.</>
                : <>You can now sign in — your data is exactly as you left it.</>}
            </p>
            <div style={proNote}>
              <strong>Heads up:</strong> if you had an active PRO subscription, it was cancelled when you deleted the account and is <strong>not</strong> automatically reactivated. Visit the Pricing page to re-subscribe.
            </div>
            <Link to="/?auth=signin" style={ctaPrimary}>Sign in →</Link>
          </>
        )}

        {state === 'failed' && (
          <>
            <div style={{ fontSize: '2.5rem', marginBottom: '0.5rem' }}>⚠️</div>
            <h1 style={title}>Link unavailable</h1>
            <p style={sub}>{errMsg}</p>
            <Link to="/?auth=signin" style={ctaPrimary}>Back to sign in →</Link>
          </>
        )}
      </div>
    </div>
  );
}

const pageStyle = {
  minHeight: '100vh', background: '#fafafa',
  fontFamily: "'Inter', sans-serif",
  display: 'flex', alignItems: 'center', justifyContent: 'center',
  padding: '1.5rem',
};
const cardStyle = {
  background: 'white', border: '1px solid #e4e4e7',
  borderRadius: 20, padding: '2.5rem 2rem',
  maxWidth: 440, width: '100%', textAlign: 'center',
  boxShadow: '0 10px 30px rgba(10,10,12,0.06)',
};
const brand = {
  display: 'inline-flex', alignItems: 'center', gap: '0.55rem',
  textDecoration: 'none', color: '#0a0a0c', marginBottom: '1.5rem',
};
const brandMark = {
  width: 32, height: 32, borderRadius: 9,
  background: 'linear-gradient(135deg,#6366f1,#ec4899)',
  display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
  fontSize: '0.85rem',
};
const brandName = {
  fontFamily: "'Syne', sans-serif", fontWeight: 800,
  fontSize: '1.05rem', letterSpacing: '-0.03em',
};
const title = {
  fontFamily: "'Syne', sans-serif",
  fontWeight: 800, fontSize: '1.55rem',
  letterSpacing: '-0.02em', color: '#0a0a0c',
  margin: '0 0 0.5rem',
};
const sub = { color: '#52525b', fontSize: '0.95rem', lineHeight: 1.55, margin: '0 0 1.5rem' };
const proNote = {
  background: '#fff7ed', border: '1px solid #fed7aa',
  borderRadius: 10, padding: '0.7rem 0.9rem',
  fontSize: '0.82rem', color: '#9a3412', lineHeight: 1.55,
  marginBottom: '1rem', textAlign: 'left',
};
const ctaPrimary = {
  display: 'inline-block', width: '100%', boxSizing: 'border-box',
  cursor: 'pointer', border: 'none',
  background: '#0a0a0c', color: 'white',
  fontFamily: "'Inter', sans-serif",
  fontWeight: 700, fontSize: '0.95rem',
  padding: '0.95rem', borderRadius: 12, marginTop: '0.25rem',
  textDecoration: 'none',
};
